import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineDoodle2Sm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 126,
	height: 12,
	viewBox: "0 0 126 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.08294 7.79731C23.061 1.2742 146.333 0.858992 120.53 2.22916C94.7263 3.59933 49 6 33 10",
		stroke: "#FFC14A",
		strokeWidth: 3,
		strokeLinecap: "round"
	})
});
export default SvgLineDoodle2Sm;
